export default "__VITE_ASSET__faB0vCvz__"